// SPDX-FileCopyrightText: 2017-2026 City of Espoo
//
// SPDX-License-Identifier: LGPL-2.1-or-later

// GENERATED FILE: no manual modifications

import type { ActiveQuestionnaire } from 'lib-common/generated/api-types/holidayperiod'
import type { FixedPeriodsBody } from 'lib-common/generated/api-types/holidayperiod'
import type { HolidayPeriod } from 'lib-common/generated/api-types/holidayperiod'
import type { HolidayQuestionnaireId } from 'lib-common/generated/api-types/shared'
import type { JsonCompatible } from 'lib-common/json'
import type { JsonOf } from 'lib-common/json'
import type { OpenRangesBody } from 'lib-common/generated/api-types/holidayperiod'
import { client } from '../../api-client'
import { deserializeJsonActiveQuestionnaire } from 'lib-common/generated/api-types/holidayperiod'
import { deserializeJsonHolidayPeriod } from 'lib-common/generated/api-types/holidayperiod'
import { uri } from 'lib-common/uri'


/**
* Generated from evaka.core.holidayperiod.HolidayPeriodControllerCitizen.answerFixedPeriodQuestionnaire
*/
export async function answerFixedPeriodQuestionnaire(
  request: {
    id: HolidayQuestionnaireId,
    body: FixedPeriodsBody
  }
): Promise<void> {
  const { data: json } = await client.request<JsonOf<void>>({
    url: uri`/citizen/holiday-period/questionnaire/fixed-period/${request.id}`.toString(),
    method: 'POST',
    data: request.body satisfies JsonCompatible<FixedPeriodsBody>
  })
  return json
}


/**
* Generated from evaka.core.holidayperiod.HolidayPeriodControllerCitizen.answerOpenRangeQuestionnaire
*/
export async function answerOpenRangeQuestionnaire(
  request: {
    id: HolidayQuestionnaireId,
    body: OpenRangesBody
  }
): Promise<void> {
  const { data: json } = await client.request<JsonOf<void>>({
    url: uri`/citizen/holiday-period/questionnaire/open-range/${request.id}`.toString(),
    method: 'POST',
    data: request.body satisfies JsonCompatible<OpenRangesBody>
  })
  return json
}


/**
* Generated from evaka.core.holidayperiod.HolidayPeriodControllerCitizen.getActiveQuestionnaires
*/
export async function getActiveQuestionnaires(): Promise<ActiveQuestionnaire[]> {
  const { data: json } = await client.request<JsonOf<ActiveQuestionnaire[]>>({
    url: uri`/citizen/holiday-period/questionnaire`.toString(),
    method: 'GET'
  })
  return json.map(e => deserializeJsonActiveQuestionnaire(e))
}


/**
* Generated from evaka.core.holidayperiod.HolidayPeriodControllerCitizen.getHolidayPeriods
*/
export async function getHolidayPeriods(): Promise<HolidayPeriod[]> {
  const { data: json } = await client.request<JsonOf<HolidayPeriod[]>>({
    url: uri`/citizen/holiday-period`.toString(),
    method: 'GET'
  })
  return json.map(e => deserializeJsonHolidayPeriod(e))
}
